<template lang="pug">
  .contact-form
    .section
      .container
        .main-btn.bg-red.col-white.open-btn(@click="modal=true") {{ gettext('Contact us') }}
    v-modal(:show.sync="thankModal" :clickAway="true")
      section.modal-card-body.requestMOdal
        h3.thank-you {{ gettext('Thank you, we will contact you as soon as possible!') }}
    v-modal(:show.sync="modal" :clickAway="true")
      section.modal-card-body.requestMOdal
        h3.title {{ gettext('Contact with us!') }}
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input.input(
            :placeholder="gettext('Name')"
            v-model="form.name"
            )
        .tile.field(v-if="(!$auth.check())")
          .field-body
            v-phone-input(
            name="phone"
            v-model="form.phone"
            @blur="validateData('phone')"
            :class="{'is-danger': $v.form.phone.$error, 'is-empty': !form.phone}"
            @onInput="form.phone = $event.number"
            :phone="form.phone"
            )
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input.input(
            :placeholder="gettext('Email')"
            v-model="form.email"
            @blur="validateData('email')"
            :class="{'is-danger': $v.form.email.$error, 'is-empty': !form.email}"
            )
        .tile.field
          .field-body
            textarea.textarea(
            rows="7"
            :placeholder="gettext('Tell us who are you looking for and we will contact you as soon as possible')"
            v-tooltip="{content: errors.required, show: tooltip.text}"
            :class="{'is-danger': $v.form.text.$error, 'is-empty': !form.text}"
            @blur="validateData('text')"
            v-model="form.text")
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input#custom-checkbox.is-checkradio.custom-checkbox(
            type="checkbox"
            v-model="form.agree"
            )
            label.checkbox(for="custom-checkbox")
              | {{ gettext('I agree to the') }} &nbsp;
              router-link(:to="`/${getLanguage}/terms-and-conditions`" target='_blank') {{ gettext('terms and conditions') }}
          label.label.is-hidden-mobile
        .tile.btns
          .main-btn.col-white.bg-red(
          @click="send()"
          :disabled="$v.$invalid || (!$auth.check() && !form.agree) || loading"
          ) {{ gettext('Send') }}
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VPhoneInput from '@/components/v-phone-input'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import VModal from '@/components/modal'
const _ = require('lodash')

export default {
  name: 'contact-form',
  data () {
    return {
      form: {
        text: '',
        name: '',
        phone: '',
        email: '',
        agree: false
      },
      modal: false,
      thankModal: false,
      loading: false,
      tooltip: {},
      sent: false
    }
  },
  components: {
    VPhoneInput,
    VTooltip,
    VModal
  },
  validations () {
    if (this.$auth.check()) {
      return {
        form: {
          text: {required}
        }
      }
    } else {
      return {
        form: {
          text: {required},
          email: {
            email,
            required: requiredIf(() => {
              return !this.form.phone
            })
          },
          phone: {
            required: requiredIf(() => {
              return !this.form.email
            })
          },
          name: {}
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'sendCvsContactsNonAuth',
      'sendCvsContactsAuth'
    ]),
    gettext: gettext,
    reset () {
      this.sent = false
      this.form = {
        text: '',
        name: '',
        phone: '',
        email: '',
        agree: false
      }
      this.$v.$reset()
    },
    validateData (item) {
      if (item) {
        this.$v.form[item].$touch()
        if (this.$v.form[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    clearRequestForm () {
      this.$v.$reset()
      this.modal = false
      this.form = {
        name: '',
        email: '',
        phone: '',
        text: '',
        agree: false
      }
    },
    send () {
      this.loading = true
      this.validateData()
      if (this.$auth.check()) {
        this.sendCvsContactsAuth({
          lang: this.getLanguage,
          form_data: {
            text: this.form.text
          }
        }).then(res => {
          if (res.success) {
            this.sent = true
            this.loading = false
            this.thankModal = true
            this.clearRequestForm()
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      } else {
        this.sendCvsContactsNonAuth({
          lang: this.getLanguage,
          form_data: {
            name: this.form.name,
            email: this.form.email,
            phoneNumber: this.form.phone,
            text: this.form.text,
            agree: this.form.agree
          }
        }).then(res => {
          if (res.success) {
            this.sent = true
            this.loading = false
            this.thankModal = true
            this.clearRequestForm()
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    errors () {
      return {
        required: gettext('This field is required')
      }
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/search/workers/parts/contact-form/index.vue